var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<product-images ng-right-click=\"$ctrl.submit()\" product=\"$ctrl.product\" expand=\"{{::$ctrl.$pageConfig.touch ? 'window' : 'off'}}\" v-height=\"{{$ctrl.$pageConfig.width<996?360:$ctrl.$pageConfig.width<1200?400:500}}px\" v-width=\"70px\" arrows=\"inside\" alt-layout=\"{{ $ctrl.$pageConfig.width < 769 ? 'h' : 'v' }}\"></product-images>";
var id1="cart-item-quick-view-image.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;